import React, { useState } from "react";
import { TermsAndConditions } from "../../../../Pages/AgentTerms/AgentTerms";
import { useOnClickOutside } from "../../../../utils/ComponentsUtils";
import "./PackagePaymentTermsConsent.scss";

/** Public terms page (same reference used elsewhere in package flow) */
const TERMS_ORDER_CONDITIONS_URL =
  "https://www.hotelsriver.com/termsAndConditions";

/**
 * Mandatory terms row below payment link CTA — packages/profile checkout only.
 * Session state is owned by parent (SelectedResultContext).
 */
const PackagePaymentTermsConsent = ({
  checked,
  onChange,
  showAttemptHint,
  checkboxId = "package-payment-terms-consent",
}) => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const modalRef = React.useRef(null);
  useOnClickOutside(modalRef, () => setIsTermsModalOpen(false));

  return (
    <div
      className="package-payment-terms-consent"
      dir="rtl"
    >
      <div className="package-payment-terms-consent__row">
        <input
          id={checkboxId}
          type="checkbox"
          className="package-payment-terms-consent__checkbox"
          checked={!!checked}
          onChange={(e) => onChange?.(e.target.checked)}
          aria-describedby={
            showAttemptHint && !checked
              ? `${checkboxId}-hint`
              : undefined
          }
        />
        <span className="package-payment-terms-consent__text">
          <label htmlFor={checkboxId} className="package-payment-terms-consent__label-hit">
            קראתי ואני מאשר/ת את{" "}
          </label>
          <a
            href={TERMS_ORDER_CONDITIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="package-payment-terms-consent__link"
          >
            התקנון
          </a>
          {" ו"}
          <button
            type="button"
            className="package-payment-terms-consent__link package-payment-terms-consent__link--button"
            onClick={() => setIsTermsModalOpen(true)}
          >
            תנאי ההזמנה
          </button>
        </span>
      </div>

      {showAttemptHint && !checked ? (
        <p
          id={`${checkboxId}-hint`}
          className="package-payment-terms-consent__hint"
          role="status"
          aria-live="polite"
        >
          יש לאשר את התקנון כדי להמשיך לתשלום
        </p>
      ) : null}

      {isTermsModalOpen ? (
        <div className="passangerData-popup-wrapper">
          <div ref={modalRef} className="passangerData-popup-frame tw-pt-4">
            <TermsAndConditions />
            <div className="passangerData-popup-agree-btn-wrapper">
              <button
                type="button"
                className="passangerData-popup-agree-btn"
                onClick={() => setIsTermsModalOpen(false)}
              >
                סגור
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PackagePaymentTermsConsent;
